import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Overlay, ModalForm } from './GenericModal.Styled';
export var ModalZIndexEnum;
(function (ModalZIndexEnum) {
    ModalZIndexEnum["min"] = "99999";
    ModalZIndexEnum["medium"] = "999999";
    ModalZIndexEnum["max"] = "1000000";
})(ModalZIndexEnum || (ModalZIndexEnum = {}));
export const GenericModal = ({ children, className, into, zIndex = ModalZIndexEnum.max }) => {
    const ref = useRef();
    const [show, setShow] = useState(false);
    useEffect(() => {
        const modalRoot = document.querySelector(`#${into}`);
        ref.current = modalRoot;
        setShow(!show);
    }, []);
    const markup = (React.createElement(Overlay, { zIndex: zIndex },
        React.createElement(ModalForm, { className: className }, children)));
    return show ? ReactDOM.createPortal(markup, ref.current) : null;
};
//# sourceMappingURL=GenericModal.js.map